module.exports = __webpack_public_path__ + "Flag-484.8b42e2156cd3e288f9498fb2e43cfec5.svg";